import { createPortal } from "react-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Printer } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-CA") : "—");

const LabelMarkup = ({ device, testid }) => (
  <div className="ppm-sticker" data-testid={testid}>
    <div className="ppm-row1">
      <div className="ppm-tag">PPM</div>
      <div className="ppm-name">{device.device_name}</div>
    </div>
    <div className="ppm-line">No: {device.biomed_no}</div>
    <div className="ppm-line">SN: {device.serial_no || "—"}</div>
    <div className="ppm-dates">
      <div className="ppm-date"><span>PPM Date</span>{fmt(device.latest_evaluation_at)}</div>
      <div className="ppm-date"><span>Next PPM</span>{fmt(device.next_evaluation_available_at)}</div>
    </div>
  </div>
);

export const PPMStickerLabel = ({ device, onClose }) => {
  if (!device) return null;

  return (
    <>
      <style>{`
        .ppm-sticker {
          width: 40mm;
          height: 22mm;
          background: #fff;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 1.2mm 1.5mm;
          direction: ltr;
          overflow: hidden;
          color: #0A0A0A;
          box-sizing: border-box;
        }
        .ppm-sticker .ppm-row1 { display: flex; align-items: center; gap: 1mm; border-bottom: 0.3mm solid #0A0A0A; padding-bottom: 0.5mm; }
        .ppm-sticker .ppm-tag { font-size: 6pt; font-weight: 800; letter-spacing: 0.5px; border: 0.3mm solid #0A0A0A; padding: 0 0.8mm; line-height: 1.4; flex-shrink: 0; }
        .ppm-sticker .ppm-name { font-size: 5.5pt; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
        .ppm-sticker .ppm-line { font-family: 'Courier New', monospace; font-size: 5.5pt; font-weight: 700; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .ppm-sticker .ppm-dates { display: flex; justify-content: space-between; gap: 1mm; }
        .ppm-sticker .ppm-date { font-size: 5pt; font-weight: 700; line-height: 1.3; }
        .ppm-sticker .ppm-date span { display: block; font-size: 4.5pt; font-weight: 600; color: #333; }

        .ppm-preview-frame { border: 1px solid #E5E7EB; border-radius: 3px; transform: scale(2); transform-origin: center; margin: 12mm 0; }
        .ppm-print-root { display: none; }

        @media print {
          @page { size: 40mm 22mm; margin: 0; }
          html, body {
            width: 40mm !important;
            height: 22mm !important;
            max-height: 22mm !important;
            overflow: hidden !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          body > *:not(.ppm-print-root) { display: none !important; }
          .ppm-print-root {
            display: block !important;
            position: fixed;
            top: 0;
            left: 0;
            visibility: visible !important;
          }
          .ppm-print-root * { visibility: visible !important; }
        }
      `}</style>

      <Dialog open={!!device} onOpenChange={(o) => !o && onClose()}>
        <DialogContent dir="rtl" className="max-w-sm">
          <DialogHeader>
            <DialogTitle>ملصق PPM</DialogTitle>
            <DialogDescription>حجم الطباعة: 4 × 2.2 سم</DialogDescription>
          </DialogHeader>

          <div className="flex justify-center py-2">
            <div className="ppm-preview-frame">
              <LabelMarkup device={device} testid="ppm-sticker-label" />
            </div>
          </div>

          <Button onClick={() => window.print()} className="w-full bg-[#655dc6] hover:bg-[#5449a8] text-white gap-2" data-testid="print-ppm-btn">
            <Printer className="w-4 h-4" /> طباعة الملصق
          </Button>
        </DialogContent>
      </Dialog>

      {createPortal(
        <div className="ppm-print-root">
          <LabelMarkup device={device} testid="ppm-sticker-print" />
        </div>,
        document.body
      )}
    </>
  );
};
